import React from 'react';
import { isEmpty } from 'lodash';
import { translate } from '@fiverr-private/i18n-react';
import { getContext } from '@fiverr-private/fiverr_context';
import { RelatedGuides } from '@fiverr-private/seo_content';
import { Section } from '@fiverr-private/layout_components';
import { useImpressionItem } from '@fiverr-private/impressionable';
import SafeComponent from '../../shared/SafeComponent';
import { BIGQUERY_REVAMP_PAGE_NAME } from '../../utils/biEvents/constants';
import { getImpressionEnrichment } from '../../utils/biEvents';
import { BQ_IMP_GUIDES_IS_SHOWN } from '../../utils/biEvents/events/bigQueryEvents';
import { LOCALE_GUIDES } from './config';

const getLocaleGuides = () => {
    const { locale } = getContext();

    return LOCALE_GUIDES[locale];
};

interface FiverrGuidesProps {
    guides?: {
        title: string;
        article_link: string;
        image_link: string;
    }[];
}

const FiverrGuides = ({ guides = getLocaleGuides() }: FiverrGuidesProps) => {
    const [ref] = useImpressionItem(getImpressionEnrichment({ eventName: BQ_IMP_GUIDES_IS_SHOWN }));

    if (isEmpty(guides)) {
        return <></>;
    }

    const transformedGuides = {
        items: guides.map((guide) => ({
            guideTitle: guide.title,
            guideUrl: guide.article_link,
            imageUrl: guide.image_link,
            imageAlt: guide.title,
        })),
    };

    return (
        <Section paddingTop={{ default: '8', md: '10' }} paddingBottom={{ default: '8', md: '10' }}>
            <div ref={ref}>
                <RelatedGuides
                    guides={transformedGuides}
                    titleClassName="h2-title"
                    title={translate<string>('logged_out_homepage.fiverr_guides.title')}
                    sourcePageKey={BIGQUERY_REVAMP_PAGE_NAME}
                />
            </div>
        </Section>
    );
};

export { FiverrGuides };
export default SafeComponent(FiverrGuides);
